import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Typography } from "@material-ui/core";
import { notArrayOrEmpty } from '../../../utils/helpers';
import BulletStatus from "../../Common/BulletStatus";
import withHeightChange from '../../HOC/withHeightChange';

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        minHeight: "5vh",
        padding: theme.spacing(1)
    },
    title: {
        padding: theme.spacing(1)
    },
    content: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(1),
        display: "flex",
        flexWrap: "wrap"
    }
});

const ReportKeywords = forwardRef((props, ref) => {
    const { classes, title, content } = props;

    const printTags = data => {
        if(notArrayOrEmpty(data))
            return;
        return content.map(tag => {
            return (
                <BulletStatus
                    key={tag}
                    background="lightgrey"
                >
                    {tag}
                </BulletStatus>
            );
        });
    };

    return (
        <Paper
            ref={ref}
            square
            className={classes.paper}
        >
            <Typography variant="subtitle1" className={classes.title}>
                {title}
            </Typography>
            <div className={classes.content}>
                {printTags(content)}
            </div>
        </Paper>
    );
})

ReportKeywords.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    content: PropTypes.array,
};

export default withStyles(useStyles)(withHeightChange(ReportKeywords));
